// extracted by mini-css-extract-plugin
export default {"root":"Security_root__6ggae","content":"Security_content__uiO5Z"};